import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import globalSettingsStores from '../../../../stores/settings-stores';

export const createPollOperation = async (
  pollName: string,
  setLoading: (isLoading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    if (pollName.length < 2 || pollName.length > 100) {
      toast.warn('על שם המשוב להיות בין 2 ל100 תווים');
      return;
    }
    setLoading(true);
    await appApi.createAbstractPoll(pollName);
    await globalSettingsStores.fetchSetting();
    toast.success('המשוב נוצר בהצלחה');
    setLoading(false);
    closeDialog();
  } catch (e) {
    toast.error('לא ניתן לבצע את הפעולה, נסה שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
